import Flatten from "@flatten-js/core";

import type { BoundingBox } from "../types.ts";
import type { Anchor, GeometricScene } from "./types.ts";

const { point } = Flatten;

export const getGeometricScene = (bounds: BoundingBox): GeometricScene => {
  const { x, y, width, height } = bounds;

  const anchors: Anchor[] = [
    { point: { x: x + width / 2, y }, edge: "TOP" },
    { point: { x: x + width, y: y + height / 2 }, edge: "RIGHT" },
    { point: { x: x + width / 2, y: y + height }, edge: "BOTTOM" },
    { point: { x, y: y + height / 2 }, edge: "LEFT" },
  ];

  const polygon = new Flatten.Polygon();
  polygon.addFace([point(x, y), point(x + width, y), point(x + width, y + height), point(x, y + height), point(x, y)]);

  return {
    anchors,
    polygon,
  };
};
